var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var Logger = /** @class */ (function () {
    function Logger(options) {
        this.prefix = options.prefix;
        this.debug = options.debug;
    }
    Logger.prototype.base = function (level) {
        var msg = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            msg[_i - 1] = arguments[_i];
        }
        if (!this.debug)
            return;
        console[level].apply(console, __spreadArrays(["[" + this.prefix + "]"], msg));
    };
    Logger.prototype.setDebug = function (debug) {
        this.debug = debug;
    };
    Logger.prototype.log = function () {
        var msg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msg[_i] = arguments[_i];
        }
        this.base.apply(this, __spreadArrays(['log'], msg));
    };
    Logger.prototype.info = function () {
        var msg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msg[_i] = arguments[_i];
        }
        this.base.apply(this, __spreadArrays(['info'], msg));
    };
    Logger.prototype.warn = function () {
        var msg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msg[_i] = arguments[_i];
        }
        this.base.apply(this, __spreadArrays(['warn'], msg));
    };
    Logger.prototype.error = function () {
        var msg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msg[_i] = arguments[_i];
        }
        this.base.apply(this, __spreadArrays(['error'], msg));
    };
    return Logger;
}());
export default Logger;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9nZ2VyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvcmUvbG9nZ2VyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFLQTtJQUlFLGdCQUFZLE9BQXNCO1FBQ2hDLElBQUksQ0FBQyxNQUFNLEdBQUcsT0FBTyxDQUFDLE1BQU0sQ0FBQztRQUM3QixJQUFJLENBQUMsS0FBSyxHQUFHLE9BQU8sQ0FBQyxLQUFLLENBQUM7SUFDN0IsQ0FBQztJQUVELHFCQUFJLEdBQUosVUFBSyxLQUF3QztRQUFFLGFBQWlCO2FBQWpCLFVBQWlCLEVBQWpCLHFCQUFpQixFQUFqQixJQUFpQjtZQUFqQiw0QkFBaUI7O1FBQzlELElBQUksQ0FBQyxJQUFJLENBQUMsS0FBSztZQUFFLE9BQU87UUFFeEIsT0FBTyxDQUFDLEtBQUssQ0FBQyxPQUFkLE9BQU8sa0JBQVEsTUFBSSxJQUFJLENBQUMsTUFBTSxNQUFHLEdBQUssR0FBRyxHQUFFO0lBQzdDLENBQUM7SUFFRCx5QkFBUSxHQUFSLFVBQVMsS0FBYztRQUNyQixJQUFJLENBQUMsS0FBSyxHQUFHLEtBQUssQ0FBQztJQUNyQixDQUFDO0lBRUQsb0JBQUcsR0FBSDtRQUFJLGFBQWlCO2FBQWpCLFVBQWlCLEVBQWpCLHFCQUFpQixFQUFqQixJQUFpQjtZQUFqQix3QkFBaUI7O1FBQ25CLElBQUksQ0FBQyxJQUFJLE9BQVQsSUFBSSxrQkFBTSxLQUFLLEdBQUssR0FBRyxHQUFFO0lBQzNCLENBQUM7SUFFRCxxQkFBSSxHQUFKO1FBQUssYUFBaUI7YUFBakIsVUFBaUIsRUFBakIscUJBQWlCLEVBQWpCLElBQWlCO1lBQWpCLHdCQUFpQjs7UUFDcEIsSUFBSSxDQUFDLElBQUksT0FBVCxJQUFJLGtCQUFNLE1BQU0sR0FBSyxHQUFHLEdBQUU7SUFDNUIsQ0FBQztJQUVELHFCQUFJLEdBQUo7UUFBSyxhQUFpQjthQUFqQixVQUFpQixFQUFqQixxQkFBaUIsRUFBakIsSUFBaUI7WUFBakIsd0JBQWlCOztRQUNwQixJQUFJLENBQUMsSUFBSSxPQUFULElBQUksa0JBQU0sTUFBTSxHQUFLLEdBQUcsR0FBRTtJQUM1QixDQUFDO0lBRUQsc0JBQUssR0FBTDtRQUFNLGFBQWlCO2FBQWpCLFVBQWlCLEVBQWpCLHFCQUFpQixFQUFqQixJQUFpQjtZQUFqQix3QkFBaUI7O1FBQ3JCLElBQUksQ0FBQyxJQUFJLE9BQVQsSUFBSSxrQkFBTSxPQUFPLEdBQUssR0FBRyxHQUFFO0lBQzdCLENBQUM7SUFDSCxhQUFDO0FBQUQsQ0FBQyxBQWxDRCxJQWtDQztBQUVELGVBQWUsTUFBTSxDQUFDIn0=